<script>
export default {
  name: "AnalyticEvents",
  methods: {
    // Wrapper sicuro: $ga viene registrato solo dopo il consenso cookie (iubenda),
    // quindi può essere undefined quando l'utente interagisce prima di accettare.
    trackGaEvent(category, action, label, value) {
      if (this.$ga) {
        this.$ga.event(category, action, label, value);
      }
    },
    // home
    trackHomeCosaFareNy() {
      this.trackGaEvent("home", "click", "Editoriale", 0);
    },
    trackHomeCambiaIsola() {
      this.trackGaEvent("home", "click", "CambiaIsola", 0);
    },
    trackHomeChiSiamo() {
      this.trackGaEvent("home", "click", "ChiSiamo", 0);
    },
    trackHomeAgenzie() {
      this.trackGaEvent("home", "click", "Agenzie", 0);
    },
    trackHomeCreaIlTuoViaggio() {
      this.trackGaEvent("home", "click", "GotoTab", 0);
    },
    trackHomeProductVoloHotel() {
      this.trackGaEvent("homeTab", "click", "TabVoloHotel", 0);
    },
    trackHomeProductTour() {
      this.trackGaEvent("homeTab", "click", "TabTour", 0);
    },
    trackHomeProductExperience() {
      this.trackGaEvent("homeTab", "click", "TabExperience", 0);
    },
    trackHomeSearchVoloHotel() {
      this.trackGaEvent("homeTab", "click", "CreaVoloHotel", 0);
    },
    trackHomeSearchTour() {
      this.trackGaEvent("homeTab", "click", "CreaTour", 0);
    },
    trackHomeSearchExperience() {
      this.trackGaEvent("homeTab", "click", "CreaExperience", 0);
    },
    trackHomeOfferteSpecialiAltreDate() {
      this.trackGaEvent("homeOfferteSpeciali", "click", "AltreDate", 0);
    },
    trackHomeOfferteSpecialiScegli() {
      this.trackGaEvent("homeOfferteSpeciali", "click", "Scegli", 0);
    },
    trackHomeOraPartireAltreDate() {
      this.trackGaEvent("homeOraPartire", "click", "AltreDate", 0);
    },
    trackHomeOraPartireScegli() {
      this.trackGaEvent("homeOraPartire", "click", "Scegli", 0);
    },
    trackHomeModaleTourProcedi() {
      this.trackGaEvent("homeModaleTour", "click", "Procedi", 0);
    },
    trackHomeModaleTourItinerario() {
      this.trackGaEvent("homeModaleTour", "click", "Itinerario", 0);
    },
    trackHomeModaleExperienceItinerario() {
      this.trackGaEvent("homeExperienceModale", "click", "Itinerario", 0);
    },
    trackResultTourModifica() {
      this.trackGaEvent("resultTour", "click", "Modifica", 0);
    },
    trackResultExperienceModifica() {
      this.trackGaEvent("resultExperience", "click", "Modifica", 0);
    },
    trackResultModaleTourProcedi() {
      this.trackGaEvent("resultTourModale", "click", "Procedi", 0);
    },
    trackResultModaleTourItinerario() {
      this.trackGaEvent("resultTourModale", "click", "Itinerario", 0);
    },
    trackResultExperienceScegli() {
      this.trackGaEvent("resultExperience", "click", "Scegli", 0);
    },
    trackResultModaleExperienceProcedi() {
      this.trackGaEvent("resultExperienceModale", "click", "Procedi", 0);
    },
    trackResultModaleExperienceItinerario() {
      this.trackGaEvent("resultExperienceModale", "click", "Itinerario", 0);
    },
    trackBreadcrumbVoloHotel() {
      this.trackGaEvent("wizardBreadcrumb", "click", "VoloHotel", 0);
    },
    trackBreadcrumbTour() {
      this.trackGaEvent("wizardBreadcrumb", "click", "Tour", 0);
    },
    trackBreadcrumbExperience() {
      this.trackGaEvent("wizardBreadcrumb", "click", "Experience", 0);
    },
    trackBreadcrumbAttivita() {
      this.trackGaEvent("wizardBreadcrumb", "click", "Attivita", 0);
    },
    trackBreadcrumbTrasferimenti() {
      this.trackGaEvent("wizardBreadcrumb", "click", "Trasferimenti", 0);
    },
    trackBreadcrumbCompleta() {
      this.trackGaEvent("wizardBreadcrumb", "click", "Completa", 0);
    },
    trackTabVoloAltreAlternative() {
      this.trackGaEvent("wizardVolo", "click", "MostraAlternative", 0);
    },
    trackTabVoloInfoVoli() {
      this.trackGaEvent("wizardVolo", "click", "Info", 0);
    },
    trackTabVoloSelezionaVolo() {
      this.trackGaEvent("wizardVolo", "click", "Cambia", 0);
    },
    trackTabTourCambiaCategoria() {
      this.trackGaEvent("wizardTour", "click", "CambiaCategoria", 0);
    },
    trackTabTourModificaInfo() {
      this.trackGaEvent("wizardTour", "click", "Info", 0);
    },
    trackModaleDettaglioTour() {
      this.trackGaEvent("wizardModaleTour", "click", "TabItinerario", 0);
    },
    trackTabHotelAltreAlternative() {
      this.trackGaEvent("wizardHotel", "click", "MostraAlternative", 0);
    },
    trackTabHotelInfo() {
      this.trackGaEvent("wizardHotel", "click", "Info", 0);
    },
    trackModaleListaHotelFiltroRating() {
      this.trackGaEvent("wizardHotelList", "click", "FiltroRating", 0);
    },
    trackModaleListaHotelSeleziona() {
      this.trackGaEvent("wizardHotelList", "click", "CambiaHotel", 0);
    },
    trackModaleListaHotelInfo() {
      this.trackGaEvent("wizardHotelList", "click", "ClickInfo", 0);
    },
    trackModaleListaHotelPrezzoMappa() {
      this.trackGaEvent("wizardHotelList", "click", "ClickPrezzoMappa", 0);
    },
    trackModalDettaglioHotelCambia() {
      this.trackGaEvent("wizardModaleHotel", "click", "CambiaHotel", 0);
    },
    trackModalDettaglioHotelChiudi() {
      this.trackGaEvent("wizardModaleHotel", "click", "Chiudi", 0);
    },
    trackModalDettaglioHotelTabDescrizione() {
      this.trackGaEvent("wizardModaleHotel", "click", "TabDescrizione", 0);
    },
    trackTabAttivitaTabBlu() {
      this.trackGaEvent("wizardAttivita", "click", "TabBlu", 0);
    },
    trackTabAttivitaCambiaData() {
      this.trackGaEvent("wizardAttivita", "click", "CambiaData", 0);
    },
    trackTabAttivitaMostraAlternative() {
      this.trackGaEvent("wizardAttivita", "click", "MostraAlternative", 0);
    },
    trackTabAttivitaInfo() {
      this.trackGaEvent("wizardAttivita", "click", "Info", 0);
    },
    trackModaleListaAttivitaFiltroData() {
      this.trackGaEvent("wizardAttivitaList", "click", "FiltroData", 0);
    },
    trackModaleListaAttivitaAggiungi() {
      this.trackGaEvent("wizardAttivitaList", "click", "Aggiungi", 0);
    },
    trackModaleListaAttivitaPrezzoMappa() {
      this.trackGaEvent("wizardAttivitaList", "click", "InfoMap", 0);
    },
    trackModaleListaAttivitaInfo() {
      this.trackGaEvent("wizardAttivitaList", "click", "Info", 0);
    },
    trackModaleListaAttivitaElimina() {
      this.trackGaEvent("wizardAttivitaList", "click", "Elimina", 0);
    },
    trackModaleAttivitaAggiungi() {
      this.trackGaEvent("wizardModaleAttivita", "click", "Aggiungi", 0);
    },
    trackModaleAttivitaTabDescrizione() {
      this.trackGaEvent("wizardModaleAttivita", "click", "TabDescrizione", 0);
    },
    trackTabTraferimentiTabBlu() {
      this.trackGaEvent("wizardTrasf", "click", "TabBlu", 0);
    },
    trackTabTraferimentiMostraAlternative() {
      this.trackGaEvent("wizardTrasf", "click", "MostraAlternative", 0);
    },
    trackModaleListaTrasferimentiAA() {
      this.trackGaEvent("wizardTrasfList", "click", "AggiungiAndata", 0);
    },
    trackModaleListaTrasferimentiRR() {
      this.trackGaEvent("wizardTrasfList", "click", "AggiungiRitorno", 0);
    },
    trackSidebarInfo() {
      this.trackGaEvent("wizardSidebar", "click", "Info", 0);
    },
    trackSidebarElimina() {
      this.trackGaEvent("wizardSidebar", "click", "Elimina", 0);
    },
    trackTabCompletaPreventivo() {
      this.trackGaEvent("wizardCompleta", "click", "Completa", 0);
    },
    trackModaleCompletaPreventivoConcludi() {
      this.trackGaEvent("wizardModaleCompleta", "click", "Concludi", 0);
    },
    trackModaleCompletaPreventivoAnnulla() {
      this.trackGaEvent("wizardModaleCompleta", "click", "Annulla", 0);
    },
    trackModaleCompletaPreventivoVisualizza() {
      this.trackGaEvent("wizardModaleCompleta", "click", "Visualizza", 0);
    },
    trackModaleCompletaPreventivoChiudi() {
      this.trackGaEvent("wizardModaleCompleta", "click", "Chiudi", 0);
    },
    trackGtmModaleCompletaPreventivoConcludi(data) {
      gtag("event", "quote", data);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/front/components/common/AnalyticEvents.vue